import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ImportService {
    private enforceOverwriteStructure: boolean = false;

    public reset() {
        this.enforceOverwriteStructure = false;
    }

    public getEnforceOverwriteStructure() {
        return this.enforceOverwriteStructure;
    }

    public setEnforceOverwriteStructure(value: boolean) {
        this.enforceOverwriteStructure = value;
    }
}
